import { useEffect, useState } from "react";

import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import { sendEmailOTP, validateOtp } from "api/OTPService";
import { Link } from "react-router-dom";
import { Alert, Box, Snackbar, Typography, Backdrop, CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

function ValidateOTP({ username, handleSignUp }) {
  // const navigate = useNavigate();
  const [error] = useState("");
  const [secretCode, setSecretCode] = useState("");
  const [isBackButtonClicked, setBackbuttonPress] = useState(false);
  const [isResetPasswordSuccess, setIsResetPasswordSuccess] = useState(true);

  // Countdown resend OTP
  const [resendCountdown, setResendCountdown] = useState(120);
  const [canResend, setCanResend] = useState(false);

  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (isBackButtonClicked) {
      setBackbuttonPress(false);
    } else {
      window.history.pushState(null, null, window.location.pathname);
      setBackbuttonPress(true);
    }
  };

  const handleCloseNotifyLogin = () => setIsResetPasswordSuccess(true);

  const handleResetPassword = async () => {
    if (secretCode.length !== 4) {
      alert("Vui lòng nhập đầy đủ 4 chữ số của mã xác thực.");
      return;
    }
    const response = await validateOtp(username, secretCode);
    if (response.status === 200) {
      console.log(secretCode);
      handleSignUp();
    } else {
      Swal.fire({
        title: "Mã xác thực không chính xác",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  const handleResendCode = async () => {
    if (!canResend) return;
    setIsLoading(true);

    const check = await sendEmailOTP(username);
    if (check) {
      setResendCountdown(120);
      setCanResend(false);
      setSecretCode(""); // reset mã cũ
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);

  useEffect(() => {
    let timer;
    if (!canResend && resendCountdown > 0) {
      timer = setTimeout(() => {
        setResendCountdown(resendCountdown - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearTimeout(timer);
  }, [resendCountdown, canResend]);

  const handleChange = (value, index) => {
    const cleaned = value.replace(/\D/, "");
    if (!cleaned) return;

    const newCode = secretCode.split("");
    newCode[index] = cleaned;
    const padded = Array(4)
      .fill("")
      .map((_, i) => newCode[i] || "");
    setSecretCode(padded.join(""));

    const nextInput = document.getElementById(`otp-${index + 1}`);
    if (nextInput) nextInput.focus();
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newCode = secretCode.split("");
      newCode[index] = "";
      setSecretCode(newCode.join(""));

      // Tự động focus ô trước nếu đang rỗng
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput && !secretCode[index]) {
        prevInput.focus();
      }
    }
  };

  return (
    <SuiBox sx={{ display: "flex", justifyContent: "center", paddingTop: "150px" }}>
      <Box style={{ width: "550px" }}>
        <SuiBox sx={{ display: "flex", alignItems: "center" }} mb={2} className="flex-column">
          <Typography sx={{ fontWeight: 900, fontSize: 25 }}>Xác nhận email</Typography>
          <Typography
            sx={{
              fontSize: "16px",
              color: "var(--gray-100)",
              fontWeight: "regular",
            }}
            mb={0.7}
          >
            Đã gửi mã xác nhận tới email của bạn
          </Typography>
        </SuiBox>

        <SuiBox className="w-100">
          <SuiBox>
            <SuiBox mb={2}>
              <SuiBox display="flex" justifyContent="center" gap={0.5} mt={4}>
                {[...Array(4)].map((_, i) => (
                  <TextField
                    key={i}
                    id={`otp-${i}`}
                    value={secretCode[i] || ""}
                    onChange={(e) => handleChange(e.target.value, i)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    inputProps={{
                      maxLength: 1,
                    }}
                    variant="outlined"
                    sx={{
                      width: "55px",
                      height: "55px",
                      "& .MuiInputBase-root": {
                        height: "100%",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      "& input": {
                        textAlign: "center",
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#1a73e8",
                        padding: 0,
                      },
                    }}
                  />
                ))}
              </SuiBox>
            </SuiBox>
            <SuiBox mb={2} textAlign="center">
              <SuiButton
                size="small"
                color="var(--blue-blue-100)"
                circular
                sx={{
                  width: "100% !important",
                  background: "var(--blue-blue-100)",
                  borderRadius: "15px",
                  padding: "8px 24px",
                }}
                onClick={handleResetPassword}
              >
                <Typography whiteSpace="nowrap" variant="body2" color="white" fontSize="14px">
                  Xác thực
                </Typography>
              </SuiButton>
            </SuiBox>{" "}
            <SuiBox mt={2} textAlign="center">
              <Typography variant="body2" fontSize="14px" color="textSecondary">
                Không nhận được email ?
                {canResend ? (
                  <button
                    type="button"
                    onClick={handleResendCode}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "var(--blue-blue-100)",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Gửi lại
                  </button>
                ) : (
                  <> Bạn có thể gửi lại sau {resendCountdown} giây</>
                )}
              </Typography>
            </SuiBox>
            <SuiBox sx={{ display: "flex", alignItems: "center" }} className="flex-column" mt={2}>
              <SuiBox sx={{ display: "flex" }}>
                <Typography sx={{ fontSize: 14 }}>Quay lại </Typography>
                <Typography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  sx={{
                    fontSize: 14,
                    marginLeft: "6px",
                    fontWeight: "regular",
                    color: "var(--blue-blue-100)",
                    cursor: "pointer",
                    textTransform: "none",
                  }}
                >
                  Đăng nhập
                </Typography>
              </SuiBox>
            </SuiBox>
          </SuiBox>
        </SuiBox>

        {isResetPasswordSuccess === false && (
          <Snackbar
            open={!isResetPasswordSuccess}
            autoHideDuration={3000}
            onClose={handleCloseNotifyLogin}
          >
            <Alert severity="error" sx={{ width: "100%" }}>
              {error}
            </Alert>
          </Snackbar>
        )}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </SuiBox>
  );
}

ValidateOTP.propTypes = {
  handleSignUp: PropTypes.func.isRequired,
};
ValidateOTP.propTypes = {
  username: PropTypes.string,
};

ValidateOTP.defaultProps = {
  username: "",
};
export default ValidateOTP;
